var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.statusColor},[_c('b',[_vm._v(" "+_vm._s(_vm.$t(`call-reporting.table.call-directions.${_vm.rowData.direction}`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }